import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ImagesIcon } from 'lucide-react';
import { useAdminData } from '../../contexts/AdminDataContext';
import { cityFromAddress, relativeAgo } from '../../utils/adminDates';
import type { Case } from '../../types/admin';
function coverOf(item: Case) {
  return item.photos.find(photo => photo.stage === 'Efter') ?? item.photos[item.photos.length - 1];
}

/** Arkiv over udførte opgaver med billeder — før/efter samlet ét sted. */
export function CasesGallery() {
  const {
    cases
  } = useAdminData();
  const finished = useMemo(() => cases.filter(item => ['Færdig', 'Faktureret'].includes(item.status) && item.photos.length > 0).sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)), [cases]);
  return <div className="px-4 py-6 md:px-8 md:py-8" data-id="element-1151" data-mp="t69nszjy8whw">
      <h1 className="font-display text-[clamp(1.8rem,5vw,2.5rem)] font-bold leading-none tracking-tight text-ink" data-id="element-1152" data-mp="t5gje58gqj2x">
        Cases
      </h1>
      <p className="mt-2 max-w-xl text-[15px] text-ink-soft" data-id="element-1153" data-mp="1ur9zvn1ce4p1">
        Færdige opgaver med billeder. Godt at have ved hånden, når en ny kunde spørger, hvad du har lavet før.
      </p>

      {finished.length === 0 ? <div className="mt-8 flex flex-col items-center rounded-card border border-dashed border-line px-6 py-14 text-center" data-id="element-1154" data-mp="24hla1rbmda4d">
          <ImagesIcon className="h-8 w-8 text-accent" strokeWidth={1.5} aria-hidden="true" data-id="element-1155" data-mp="1zp1q8cmc9ir4" />
          <p className="mt-4 text-[15px] font-medium text-ink" data-id="element-1156" data-mp="2dggbyr7mry1v">Ingen cases endnu</p>
          <p className="mt-1 max-w-sm text-sm text-ink-muted" data-id="element-1157" data-mp="28hwrywclkwc5">
            Når en sag er markeret Færdig og har billeder, dukker den op her.
          </p>
        </div> : <ul className="mt-6 grid gap-4 sm:grid-cols-2 xl:grid-cols-3" data-id="element-1158" data-mp="2igks2g4mmqrk">
          {finished.map(item => {
        const cover = coverOf(item);
        const before = item.photos.find(photo => photo.stage === 'Før');
        const hasAfter = item.photos.some(photo => photo.stage === 'Efter');
        return <li key={item.id} data-id="element-1159" data-mp="1dstdte0uop74">
                <Link to={`/admin/sager/${item.id}`} className="group flex h-full flex-col overflow-hidden rounded-card border border-line bg-white transition-colors duration-150 hover:border-accent/50" data-id="element-1160" data-mp="1dtlbqvhx6z0k">
                  <div className="relative aspect-[4/3] bg-canvas-deep" data-id="element-1161" data-mp="1rrt2glod543a">
                    {cover && <img src={cover.url} alt={item.title} className="h-full w-full object-cover" loading="lazy" data-id="element-1162" data-mp="1wp1nqv4t5o8r" />}
                    {before && hasAfter && <span className="absolute bottom-3 left-3 flex items-center gap-2 rounded-lg bg-black/60 p-1 pr-2.5 text-xs text-[#f4f1ea] backdrop-blur" data-id="element-1163" data-mp="25iemwetgtm3a">
                        <img src={before.url} alt="" className="h-8 w-8 rounded-md object-cover" data-id="element-1164" data-mp="2agzrsrjnwty2" />
                        Før / efter
                      </span>}
                  </div>
                  <div className="flex flex-1 flex-col p-4" data-id="element-1165" data-mp="2kfx9pbml1p83">
                    <p className="text-[15px] font-semibold text-ink" data-id="element-1166" data-mp="8slnwznsv3ia">{item.title}</p>
                    <p className="mt-0.5 text-sm text-ink-muted" data-id="element-1167" data-mp="3spl33qu9i4b">
                      {[item.customerName, cityFromAddress(item.address)].filter(Boolean).join(' · ')}
                    </p>
                    <p className="mt-auto pt-3 text-xs text-ink-faint" data-id="element-1168" data-mp="3q0p9khe65u9q">
                      {item.category} · {item.photos.length} billeder · {relativeAgo(item.updatedAt)}
                    </p>
                  </div>
                </Link>
              </li>;
      })}
        </ul>}
    </div>;
}